<template>
  <div>

    <lk-form slot='content' :model='goodsForm' :rules='validate' :label-width='134'
      label-position="right" ref="goodsForm">
      <div class="cardContainer">

        <lk-card title='基础商品信息'>

          <!-- 商品最开始验证部分 -->

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='商品名称:' prop='approvedDrugNames' ref="approvedDrugNames">
                <div v-if="able">

                  <goodsDropDownInput v-if='isAdd &&isInStore' :type='type'
                    v-model.trim="goodsForm.approvedDrugNames" @selected='handleSelect'
                    @on-blur='setMnemonicCode'></goodsDropDownInput>

                  <lk-input @on-change='setMnemonicCode(goodsForm.approvedDrugNames)'  :disabled='disabledSearch'
                    v-model.trim="goodsForm.approvedDrugNames" :maxlength='40' v-else clearable
                    placeholder="请输入"></lk-input>
                </div>
                <span v-else>{{goodsForm.approvedDrugNames}}</span>
              </lk-form-item>
            </lk-col>


            <!-- <lk-col span='7' :offset='1'>
              <lk-form-item label='注册证号:' prop='approvalNumber'>

                <lk-input :maxlength='30' v-if="able"
                  :disabled='disabledSearch' placeholder="请输入"
                  v-model.trim="goodsForm.approvalNumber"></lk-input>
                <span
                  v-else>{{goodsForm.approvalNumber}}</span>

              </lk-form-item>
            </lk-col> -->

            <lk-col span='7' :offset='1'>
              <lk-form-item label='包装规格' prop='specifications'>
                <lk-input :maxlength='32' v-if="able" placeholder="请输入" :disabled='isInStore&&disabledSearch'
                  v-model.trim="goodsForm.specifications"></lk-input>
                <span v-else>{{goodsForm.specifications}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='包装单位:' prop='drugMiniPackageUnit'>
                <lk-select v-if="able" clearable
                  v-model.trim="goodsForm.drugMiniPackageUnit" :disabled='!isAdd || isImport'>
                  <lk-option v-for="(item,index) in baseData.drugMiniPackageUnitArr" :key="index"
                    :value='item. dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  <!-- <lk-option :value='1'>盒</lk-option> -->
                </lk-select>
                <span
                  v-else>{{goodsForm.drugMiniPackageUnitString}}</span>
              </lk-form-item>
            </lk-col>
  </lk-row>
          <lk-row :gutter="16">


            <lk-col span='7'>
              <lk-form-item label='生产企业:' prop='manufacturer'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入" :disabled='isInStore&&disabledSearch'
                  v-model.trim="goodsForm.manufacturer"></lk-input>
                <span v-else>{{goodsForm.manufacturer}}</span>
              </lk-form-item>
            </lk-col>


            <lk-col span='7'  :offset='1'>
              <lk-form-item label='是否进口:' prop='isImport'>
                <lk-radio-group v-if="able" v-model.trim="goodsForm.isImport">
                  <lk-radio :label="1" :value="1" >是</lk-radio>
                  <lk-radio :label="2" :value="2" >否</lk-radio>
                </lk-radio-group>
                <span v-else>{{isImportArr[goodsForm.isImport]}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='质检标准:' prop='drugAcceptanceStandard'>
                <lk-input :maxlength='50' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.drugAcceptanceStandard"></lk-input>
                <span v-else>{{goodsForm.drugAcceptanceStandard}}</span>
              </lk-form-item>
            </lk-col>
            </lk-row>
          <lk-row :gutter="16">

            <lk-col span='7' >

              <lk-form-item label='储存条件:' prop='storageConditions'>
                <div >

                  <lk-select v-if="able" clearable
                    v-model.trim="goodsForm.storageConditions"
                    @on-change='handleStorageConditions'
                    :class="{'other':goodsForm.storageConditions===6}">
                    <lk-option v-for="(item,index) in baseData.storageConditionsArr" :key="index"
                      :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  </lk-select>
                  <lk-input :maxlength='10' style="width:60%" v-if="able && goodsForm.storageConditions === 6"
                    v-model.trim="goodsForm.otherStorageCondition"></lk-input>

                  <span v-if='!able'>
                    <span>
                      {{goodsForm.storageConditionsStringNew}}
                    </span>
                  </span>
                </div>
              </lk-form-item>
              <lk-form-item v-if="able&&goodsForm.storageConditions > 0" prop='temp'>
                <div  class="fakeFormItem">
                    <label style="width:26px">温度：</label>
                    <lk-input-number v-model="goodsForm.minTemp" style="width:calc(50% - 25px)"
                    placeholder="最低温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                    <label style="margin:0 4px">-</label>
                    <lk-input-number v-model="goodsForm.maxTemp" style="width:calc(50% - 25px)"
                    placeholder="最高温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                  </div>
              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>
              <lk-form-item label='条形码:' prop='barCode'>
                <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.barCode"></lk-input>
                <span v-else>{{goodsForm.barCode}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='商品分类:' prop='indicationDicId'>
                <lk-cascader v-if="able" clearable :data="baseData.indicationTree"
                  v-model.trim="indicationDicArray"></lk-cascader>
                <span v-else>{{goodsForm.indicationDicString}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>

          <lk-row :gutter='16'>


            <lk-col span='7'>
              <lk-form-item label='商品名:' prop='goodsName'>
              <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
              v-model.trim="goodsForm.goodsName"></lk-input>
                <span v-else>{{goodsForm.goodsName}}</span>
              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>
              <lk-form-item label='说明书:' prop='manualUrl'>
                <Uploader :able='able' v-model='goodsForm.manualUrl'></Uploader>
                <!-- <span v-else>{{indicationDicString}}</span> -->
              </lk-form-item>
            </lk-col>
              <lk-col span='7' :offset='1'>
                  <lk-form-item label='商品图片:' prop='drugImageUrl'>

                    <Uploader :able='able' v-model.trim="goodsForm.drugImageUrl">
                    </Uploader>
                  </lk-form-item>
                </lk-col>

          </lk-row>
          <lk-row>
            <lk-col span='7'>
              <drugInstruction :approvalNumber='goodsForm.approvalNumber' :approvedDrugNames='goodsForm.approvedDrugNames'
                :manufacturer='goodsForm.manufacturer' :specifications='goodsForm.specifications'></drugInstruction>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">
        <lk-card title='商品标签'>


          <lk-row :gutter='16'>
            <lk-col span='7'>

              <lk-form-item label='GSP管理分类:' class="storeSelect" prop='gspIdList'>
                <lk-select v-if="able" v-model="goodsForm.gspIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.gspArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.gsps }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>

              <lk-form-item label='经营范围:' class="storeSelect" prop='bizIdList'>
                <lk-select v-if="able" v-model="goodsForm.bizIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.bizArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.bizs }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>

              <lk-form-item label='生产范围:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.prodIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.prodArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.prods }}</span>
              </lk-form-item>
            </lk-col>


          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>

              <lk-form-item label='其他:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.otherIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.otherArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.others }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">

        <lk-card title='证件信息'>
          <lk-form :label-width='130' label-position="right" :model='goodsForm'
            ref="groupCheck" :rules='groupCheck'>
            <lk-row :gutter='16'>
              <lk-col class="backGroundCard" span='7'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='prodLicenseUrl' ref="prodLicenseUrl">
                      <div class="label withPic">
                        <label>生产许可证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.prodLicenseUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='prodLicenseCode' ref="prodLicenseCode">
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.prodLicenseCode"></lk-input>
                      <span v-else>{{goodsForm.prodLicenseCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodProdLicense' ref="periodProdLicense">
                      <expire-picker :able='able' :type='1' v-model.trim="goodsForm.periodProdLicense"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
              <lk-col class="backGroundCard" span='7' :offset='1' v-if="isShowProHeaCre">
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='hygieneLicenseUrl' ref="hygieneLicenseUrl">
                      <div class="label withPic">
                        <label>生产企业卫生许可证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.hygieneLicenseUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='hygieneLicenseCode' ref="hygieneLicenseCode">
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.hygieneLicenseCode"></lk-input>
                      <span v-else>{{goodsForm.hygieneLicenseCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodHygieneLicense' ref="periodHygieneLicense">
                      <expire-picker :able='able' :type='1' v-model.trim="goodsForm.periodHygieneLicense"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
              <lk-col class="backGroundCard" span='7' :offset='1' v-if="isShowProSafeReport">
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='prodLicenseReportUrl'>
                      <div class="label withPic">
                        <label>产品卫生安全评价报告或新消毒产品卫生许可批件:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.prodLicenseReportUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='prodLicenseReportCode'>
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.prodLicenseReportCode"></lk-input>
                      <span v-else>{{goodsForm.prodLicenseReportCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodProdLicenseReport'>
                      <expire-picker :able='able' :type='1' v-model.trim="goodsForm.periodProdLicenseReport"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </lk-form>


  </div>
</template>

<script>
import Uploader from '../../Uploader.vue';
import ExpirePicker from '../../expireInfo/expirePicker.vue';
import goodsDropDownInput from '../goodsDropDownInput.vue';
import drugInstruction from '../../drugInstruction.vue' //药品说明书

export default {
  name: 'Others',
  components: {

    Uploader,
    goodsDropDownInput,
    ExpirePicker,
    drugInstruction
  },
  props: {
    info: {
      type: Object,
      // required: true,
    },
    able: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },

    isInStore: {
      type: Boolean,
      default: false,
    },
    isImport: {
      type: Boolean,

    },
    type: {
      type: Number,
      required: true,
    },
    isFromBaseInfo: { // 药品类型和消杀类型的时间等是非必填
      type: Boolean,
      default: false,
    },
    requiredPeriodProdLicense: {// 生产许可证的有效期是否必选
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'info',
    event: 'change',

  },
  computed: {
    isAdd() {
      return !this.$route.params.id;
    },
    disabledSearch() {
      return !!this.$route.params.id || this.isImport;
    },
    isShowProHeaCre() { // 控制是否展示生产企业卫生许可证 6:消毒消杀。更多枚举值请看'src/store/publicParams.js'中的goodsTypes数组。
      return [6].includes(this.type);
    },
    isShowProSafeReport() { // 控制是否展示产品卫生安全评价报告或新消毒产品卫生许可批件
      return [6].includes(this.type);
    }
  },
  watch: {
    info: {
      handler() {
        console.log(this.info);
        this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];

        this.goodsForm = this.info;
      },
      deep: true,
    },
    goodsForm: {
      handler() {
        this.firstCheck();
        this.$emit('change', this.goodsForm);
      },
      deep: true,
    },
    indicationDicArray: {
      handler(val) {
        if (val && val.length) {
          this.goodsForm.indicationDicId = val[val.length - 1];
          this.goodsForm.indicationDicArray = val.join(',');
        } else {
          this.goodsForm.indicationDicId = null;
          this.goodsForm.indicationDicArray = '';
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      disableExistsTest: false,
      isImportArr: ['', '是', '否'],
      groupCheck: {
        periodProdLicense: [{
          required: this.requiredPeriodProdLicense, message: '请选择有效期', trigger: 'change', type: 'number',
        }],
      },
      validate: {
        specifications: [
          { required: true, message: '请输入规格', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        approvedDrugNames: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        manufacturer: [
          { required: true, message: '请输入生产企业', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        drugMiniPackageUnit: [
          {
            required: true, type: 'number', message: '请输入包装单位', trigger: 'change'
          },
          {
            validator: this.ifSelectDrugMiniPackageUnit, trigger: 'change'
          }
        ]
      },
      // inExists: true,
      // disabledSearch: false,
      goodsForm: {
        isImport: 2,
        storageConditions: 1,
        minTemp: null,
        maxTemp: null,
      },
      firstFill: {},
      indicationDicArray: [],

    };
  },
  methods: {
    handleStorageConditions(val) {
      if (val === 1) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 2) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 3) {
        this.goodsForm.minTemp = 0;
        this.goodsForm.maxTemp = 20;
      } else if (val === 4) {
        this.goodsForm.minTemp = 2;
        this.goodsForm.maxTemp = 8;
      } else if (val === 5) {
        this.goodsForm.minTemp = -25;
        this.goodsForm.maxTemp = -20;
      } else {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      }
    },
    firstCheck() {
      this.goodsForm.approvedDrugNames && (this.$refs.approvedDrugNames.validateState = '');// 强制清除验证状态

      if (this.isInStore && !(this.goodsForm.approvedDrugNames || this.goodsForm.specifications || this.goodsForm.manufacturer)) {
        this.disableExistsTest = true;
        let firstFill = null;

        ['approvedDrugNames',
          'specifications',
          'manufacturer',
        ].forEach((item) => {
          console.log(item);

          this.$refs.goodsForm.validateField(item, (msg) => {
            console.log(msg);
            if (msg) {
              firstFill = msg;
            }
          });
        });
        if (firstFill) {
          this.$Message.error('请先填写商品名称 和 规格 和 生产企业');
        }
        this.disableExistsTest = false;
      }
    },
    setMnemonicCode(name) {
      this.$emit('setMnemonicCode', name);
    },
    handleSelect(data) {
      console.log(data);
      this.$emit('import', data);
    },
    validateForm(isSubmit) {
      this.$emit('change', this.goodsForm);
      return new Promise((resolve) => {
        let validate = true;
        this.disableExistsTest = true;
        if (isSubmit) {
          this.$refs.goodsForm.validate((goodsFormValid) => {
            this.$refs.groupCheck.validate((groupCheckValid) => {
              resolve(goodsFormValid && groupCheckValid);
              this.disableExistsTest = false;
            });
          });
        } else {
          [
            'approvedDrugNames',
            'specifications',
            'manufacturer',
            'drugMiniPackageUnit'
          ].forEach((item) => {
            this.$refs.goodsForm.validateField(item, (msg) => {
            // console.log(msg);
              if (msg) {
                validate = false;
              }
            });
          });
          this.$nextTick(() => {
            this.disableExistsTest = false;
            resolve(validate);
          });
        }
      });
    },

    testTemp(rule, value, callback) {
      if (this.goodsForm.maxTemp != null && this.goodsForm.minTemp != null && this.goodsForm.maxTemp <= this.goodsForm.minTemp) {
        callback(
          new Error('最高温度应大于最低温度'),
        );
      }
      if (this.goodsForm.storageConditions === 6) {
        if (this.goodsForm.maxTemp === null && this.goodsForm.minTemp === null) {
          callback(
            new Error('当前储存条件下，温度必填'),
          );
        } else callback();
      } else if (this.goodsForm.storageConditions > 2) {
        if (this.goodsForm.maxTemp === null || this.goodsForm.minTemp === null) {
          callback(
            new Error('请输入完整温度范围'),
          );
        } else callback();
      } else callback();
    },
    testOtherStorage(rule, value, callback) {
      if (this.goodsForm.storageConditions === 6 && !this.goodsForm.otherStorageCondition) {
        callback(
          new Error('请输入储存条件名称'),
        );
      } else {
        callback();
      }
    },
    existsTest(rule, value, callback) {
      if (!this.disabledSearch && this.goodsForm.approvedDrugNames && this.goodsForm.manufacturer && this.goodsForm.specifications && !this.disableExistsTest) {
        this.$emit('change', this.goodsForm);

        const temp = {
          approvedDrugNames: this.goodsForm.approvedDrugNames,
          manufacturer: this.goodsForm.manufacturer,
          specifications: this.goodsForm.specifications,
        };
        // temp.specifications = temp.specifications.split(' ').join('');


        this.$emit('handleExist', temp);
      }
      callback();
    },
    ifSelectDrugMiniPackageUnit(rule, value, callback) {
      if(!this.goodsForm.drugMiniPackageUnit) {
        callback(new Error('请选择包装单位'));
      } else {
        callback();
      }
    },
  },

  created() {
    if (this.isInStore) {
      this.validate = {
        approvedDrugNames: [
          { required: true, message: '请输入通用名', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },

        ],
        // approvalNumber: [
        //   { required: true, message: '请输入注册证号', trigger: 'change' },
        //   { validator: this.existsTest, trigger: 'blur' },
        // ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        manufacturer: [
          { required: true, message: '请输入生产企业', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],

        temp: [{ required: true, validator: this.testTemp, trigger: 'blur' }],
        gspIdList: [{
          required: true, message: '请选择GSP管理分类', trigger: 'change', type: 'array',
        }],
        bizIdList: [{
          required: true, message: '请选择药品经营范围', trigger: 'change', type: 'array',
        }],

        // isDataLink: [
        //   {
        //     required: true, message: '请选择是否数据直连', trigger: 'change', type: 'integer',
        //   },
        // ],

        drugMiniPackageUnit: [
          {
            required: true, message: '请选择包装单位', trigger: 'change', type: 'number',
          },
        ],
        storageConditions: [
          {
            required: true, message: '请选择储存条件', trigger: 'change', type: 'number',
          },
          { validator: this.testOtherStorage, trigger: 'blur' },
        ],

        // manufacturer: [
        //   { required: true, message: '请输入生产企业', trigger: 'change' },
        // ],

        qualityOfDrugsType: [
          {
            required: true, message: '请选择质检分类', trigger: 'change', type: 'number',
          },
        ],
        drugAcceptanceStandard: [
          { required: !(this.type === 9 || this.type === 10 || this.type === 11 || this.type === 12), message: '请输入质检标准', trigger: 'change' },
        ],
        prodLicenseCode: [{
          required: true, message: '请填写证件号', trigger: 'change',
        }],
        periodProdLicense: [{
          required: false, message: '请选择有效期', trigger: 'change', type: 'number',

        }],
        gmpCertCode: [{ required: true, message: '请填写证件号', trigger: 'change' }],
        periodGmpCert: [{
          required: true, message: '请选择有效期', trigger: 'change', type: 'number',
        }],

      };
    }
    if ([6].includes(this.type)) { // 如果type是6消毒消杀，需要增加额外校验规则。
      this.groupCheck.prodLicenseUrl = [
        { required: !this.isFromBaseInfo, message: '请上传生产许可证', trigger: 'change' },
      ];
      this.groupCheck.prodLicenseCode = [
        { required: !this.isFromBaseInfo, message: '请输入证件号', trigger: 'change' }
      ];
      this.groupCheck.hygieneLicenseUrl = [
        { required: !this.isFromBaseInfo, message: '请上传生产企业卫生许可证', trigger: 'change' }
      ];
      this.groupCheck.hygieneLicenseCode = [
        { required: !this.isFromBaseInfo, message: '请输入证件号', trigger: 'change' }
      ];
      this.groupCheck.periodHygieneLicense = [
        { required: !this.isFromBaseInfo, message: '请选择有效期', trigger: 'change', type: 'number' }
      ];
    }
    if (!this.able) {
      this.validate = {};
      this.groupCheck = {};
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.goodsForm = this.info;
      this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];
    }
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }

  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
   .fakeFormItem{
    margin-left: -36px
  }
  .other{
    width: 40%;
  }
</style>
